import { Model } from '@vuex-orm/core';
import { AxiosResponse } from 'axios';
import PriceListRegionAPI from '@/api/PriceListRegionAPI';
import { SessionStorageService as ss } from '@/services/SessionStorageService';

export default class PriceListRegion extends Model {
    public static entity = 'priceListRegion';

    public get getName() {
        // @ts-ignore
        return this.name;
    }

    public static fields() {
        return {
            id: this.attr(null),
            name: this.string(''),
            ingeniousId: this.string(''),
        };
    }

    public static async getAll() {
        let priceListRegion;
        if (ss.has('priceListRegion')) {
            priceListRegion = ss.getAndParse('priceListRegion');
        } else {
            try {
                const fetchedPriceListRegion = (await PriceListRegionAPI.getAll()) as AxiosResponse;
                priceListRegion = fetchedPriceListRegion.data;
                ss.stringifyAndSave('priceListRegion', priceListRegion);
            } catch (e) {
                return Promise.reject(e);
            }
        }
        this.insertOrUpdate({ data: priceListRegion });
        return Promise.resolve(priceListRegion);
    }

    public static async getById(id: string | number) {
        try {
            const response = await PriceListRegionAPI.getAll() as AxiosResponse;
            return Promise.resolve(response);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async createNew(data: any) {
        try {
            const response = await PriceListRegionAPI.create(data) as AxiosResponse;
            const priceListRegions = ss.getAndParse('priceListRegion') || [];
            priceListRegions.push(response.data);
            ss.stringifyAndSave('priceListRegion', priceListRegions);
            this.insertOrUpdate({ data: response.data });
            return Promise.resolve(response);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async updateExisting(id: string | number, data: any) {
        try {
            const response = await PriceListRegionAPI.update(id, data) as AxiosResponse;
            const priceListRegions = ss.getAndParse('priceListRegion') || [];
            const index = priceListRegions.findIndex((r: any) => r.id === id);
            if (index !== -1) {
                priceListRegions[index] = response.data;
                ss.stringifyAndSave('priceListRegion', priceListRegions);
            }
            this.insertOrUpdate({ data: response.data });
            return Promise.resolve(response);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async deleteExisting(id: string | number) {
        try {
            await PriceListRegionAPI.delete(id) as AxiosResponse;
            const priceListRegions = ss.getAndParse('priceListRegion') || [];
            const updated = priceListRegions.filter((r: any) => r.id !== id);
            ss.stringifyAndSave('priceListRegion', updated);
            await PriceListRegion.delete(id);
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async setDefault(id: string | number) {
        try {
            const response = await PriceListRegionAPI.setDefault(id) as AxiosResponse;
            return Promise.resolve(response);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}